import { isDumpsterSearchTable } from 'owa-mail-list-search';
import { isDumpsterTable, getSelectedTableView } from 'owa-mail-list-store';

export function isDumpsterOrDumpsterSearchTable(): boolean {
    const tableQuery = getSelectedTableView()?.tableQuery;
    return isDumpsterTable(tableQuery) || isDumpsterSearchTable(tableQuery);
}
